import { useState } from "react";
import { EMPTY_FILTER, RepoFilterBar, filterRepos } from "../components/RepoFilter";
import type { RepoFilter, RepoLike } from "../components/RepoFilter";
import { tx } from "../i18n";

/* ══ 패턴 페이지 › 건 저장소 거르개(t-in-port-work-repos) ══
   소유자 탭 · 검색 · 연결 · 남은 수 · 비우기. 손으로 눌러 볼 수 있게 상태를 든다 — 서버를 안 부른다. */

const ROWS: RepoLike[] = [
  { id: "r1", owner: "irolab-co", name: "b3x-in", cloneUrl: "https://git.example/irolab-co/b3x-in.git", webUrl: null, connectionId: "c1", projectIds: ["in.b3x.app"] },
  { id: "r2", owner: "irolab-co", name: "mops-cmmn-code", cloneUrl: "https://git.example/irolab-co/mops-cmmn-code.git", webUrl: null, connectionId: "c1", projectIds: ["in.b3x.app"] },
  { id: "r3", owner: "irolab-co", name: "irolab-svc-hosts", cloneUrl: "https://git.example/irolab-co/irolab-svc-hosts.git", webUrl: null, connectionId: null, projectIds: [] },
  { id: "r4", owner: "platform", name: "api", cloneUrl: "https://gitea.local/platform/api.git", webUrl: null, connectionId: "c2", projectIds: ["p-api"] },
  { id: "r5", owner: "kr.mops", name: "store-mops", cloneUrl: "https://gitea.local/kr.mops/store-mops.git", webUrl: null, connectionId: "c2", projectIds: [] },
];
const CONNS = [
  { id: "c1", label: "github · irolab" },
  { id: "c2", label: "gitea · 사내" }, // copy-ignore: 견본 자료
];

function Demo({ start }: { start: RepoFilter }) {
  const [f, setF] = useState(start);
  const shown = filterRepos(ROWS, f);
  return (
    <div>
      <RepoFilterBar rows={ROWS} value={f} conns={CONNS} shown={shown.length} onChange={setF} />
      <ul className="caption">
        {shown.map((r) => (
          <li key={r.id}>
            {r.owner}/{r.name}
          </li>
        ))}
      </ul>
    </div>
  );
}

export function RepoFilterStates() {
  return (
    <>
      <h3>{tx("pat.git.filter")}</h3>
      <Demo start={EMPTY_FILTER} />
      <h3>{tx("pat.git.filterOn")}</h3>
      <Demo start={{ tab: "irolab-co", q: "mops", conn: "" }} />
    </>
  );
}
